import React, { memo, ReactNode, FC } from 'react';
import {
  useSubjectId,
  useSubjectMeta,
  UseSubjectMetaSelector
} from '@surveycake/react-logic-engine';
import { Typography } from '@surveycake/rc';
import { ColorResolver } from '@surveycake/rc';
import { SlateHtml } from 'app/shared/components';
import * as styles from './styles';

export interface TitleProps {
  children?: ReactNode;
}

const textSelector: UseSubjectMetaSelector<string> = meta => meta.text;
const colorSelector: ColorResolver = theme => theme.survey.color.black;

const Title: FC<TitleProps> = ({ children }) => {
  const id = useSubjectId();
  const text = useSubjectMeta(id, textSelector);

  return (
    <Typography
      className={styles.title}
      variant="h5"
      color={colorSelector}
      gutterBottom
    >
      <SlateHtml html={text} />
      {children}
    </Typography>
  );
};

export default memo(Title);
